import React, { lazy } from "react";
import { Route, Routes } from "react-router-dom";

const DefaultAppLayout = lazy(() => import("@/areas/apps/components/layouts/DefaultAppLayout"));
const MyProfilePage = lazy(() => import("@/areas/activities/containers/pages/MyProfilePage"));
const SubscriberActivitiesPage = lazy(() => import("@/areas/activities/containers/pages/SubscriberActivitiesPage"));

const MyProfileRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<DefaultAppLayout />}>
        <Route index element={<SubscriberActivitiesPage />} />
      </Route>
    </Routes>
  );
};

export default MyProfileRoutes;
